'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var NthTextLink = require('@narvar/nth-bit-text-link');
var ViewportConfigProvider = require('../../providers/ViewportConfigProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var NthTextLink__default = /*#__PURE__*/_interopDefaultLegacy(NthTextLink);

const TextLink = _ref => {
  let {
    href,
    target,
    stopPropagation,
    onClick,
    ...props
  } = _ref;
  const {
    externalLinkHandler
  } = ViewportConfigProvider.useViewportConfig();
  const isExternal = !!href && !onClick;
  const t = target === '_self' ? NthTextLink.TextLinkTargetType.SELF : target === '_blank' ? NthTextLink.TextLinkTargetType.BLANK : target;
  const onClickHandler = isExternal ? event => {
    event.preventDefault();
    if (stopPropagation) event.stopPropagation();
    if (externalLinkHandler) {
      externalLinkHandler({
        url: href ?? '',
        target: t
      });
    } else {
      window.open(href ?? '', t);
    }
  } : onClick;
  return /*#__PURE__*/React__default["default"].createElement(NthTextLink__default["default"], _extends__default["default"]({
    href: href,
    target: t,
    onClick: onClickHandler
  }, props));
};

exports["default"] = TextLink;
